export const colors = {
  red: {
    400: "#e7505a",
    500: "#ed2623",
  },
  redAlpha: {
    500: "#ed262390",
  },
  white: {
    500: "#FFF",
  },
  green: {
    400: "#1BBC9B",
  },
  gray: {
    100: "#e9ecf3",
    400: "#898989",
  },
  yellow: {
    400: "#F4D03F",
  },
  blue: {
    400: "#578ebe",
    900: "#2C3E50",
  },
  purple: {
    200: "#b691ed",
    500: "#8B6ED6",
    700: "#2f0869",
  },
  purpleAlpha: {
    300: "#8B6ED620",
    400: "#8B6ED633",
    500: "#8B6ED650",
    800: "#8B6ED680",
    900: "#8B6ED690",
  },
  black: {
    400: "#323232",
  },
  textGrey: {
    500: "#7E7E7E",
    600: "#898989",
    700: "#5A5A5A",
  },
  textAlpha: {
    500: "#7E7E7E50",
    600: "#89898950",
  },
};
